import React from "react";
import ReactDOM from "react-dom/client";
// Schriften lokal ausliefern statt von fonts.googleapis.com: Ein Abruf bei
// Google überträgt die IP-Adresse ohne Einwilligung (LG München I, 3 O 17493/20).
import "@fontsource/instrument-serif/400.css";
import "@fontsource/instrument-serif/400-italic.css";
import "@fontsource/outfit/400.css";
import "@fontsource/outfit/500.css";
import "@fontsource/outfit/600.css";
import "./index.css"; // <- ZUERST
import "./fonts.css"; // <- DANACH
import App from "./App";
import { watchSystemTheme } from "./theme";

watchSystemTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
